import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import tw from 'tailwind-styled-components';
import { FaSearch } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import Pagination from '../../../../components/Pagination';
import { useForm } from 'react-hook-form';
import { getUsersSearchService } from '../../../../services/externalv2_2';

const titles = {
  '2': 'ข้อมูลผู้ปกครอง',
  '3': 'ข้อมูลคุณครู',
};

const infomationLink = {
  '2': '/sornthai/dashboard-parent?parentid=',
  '3': '/sornthai/dashboard-teacher?teacherid=',
};

const SearchUser = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const role = searchParams.get('role');

  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, _] = useState<number>(10);
  const [users, setUsers] = useState<any>({
    groups: [],
  });

  const { register, handleSubmit, getValues } = useForm({
    defaultValues: {
      search: '',
    },
  });

  const onSubmitHandler = useCallback(() => {
    const values = getValues();
    const params = {
      size: rowsPerPage,
      page,
      ...values,
      ...(role ? { role } : {}),
    };

    getUsersSearchService(params).then((data) => {
      setUsers(data.results);
    });
  }, [getValues]);

  const getUsers = () => {
    const params = {
      size: rowsPerPage,
      page,
      ...(role ? { role } : {}),
    };

    getUsersSearchService(params).then((data) => {
      setUsers(data.results);
    });
  };

  const getAgeInThaiFormat = (birthDate: string) => {
    const birth = dayjs(birthDate, 'DD-MM-YYYY');
    const current = dayjs();

    const years = current.diff(birth, 'year');
    birth.add(years, 'years'); // add the number of years to the birth date to calculate months

    const months = current.diff(birth, 'months') % 12;

    return `${years} ปี ${months} เดือน`;
  };

  useEffect(getUsers, [page]);

  return (
    <div className="flex flex-col gap-6 rounded-xl border border-stroke bg-white shadow-default p-8">
      <div className="text-black text-2xl font-bold">
        {titles[role as keyof typeof titles] || 'บัญชีผู้ใช้งาน'}
      </div>

      <div className="flex flex-col">
        <div className="flex flex-col gap-4 px-4 justify-between xl:flex-row">
          <div className="flex gap-4">
            <Input
              type="text"
              className="w-[500px]"
              placeholder="ระบุคำค้นหา ..."
              {...register('search')}
            />

            <div className="self-center">
              <button
                type="button"
                onClick={handleSubmit(onSubmitHandler)}
                className="rounded-full border border-[#D9D9D9] bg-[#D9D9D9] p-2 hover:bg-[#FFFFFF]"
              >
                <FaSearch fontSize={24} />
              </button>
            </div>

            {/* <div className="self-center">
              <button
                type="button"
                className="rounded-full border border-[#D9D9D9] bg-[#D9D9D9] p-2 hover:bg-[#FFFFFF]"
              >
                <GrSearchAdvanced fontSize={24} />
              </button>
            </div> */}
          </div>
        </div>

        <div className="container mx-auto p-4 overflow-auto">
          <table className="min-w-full border-collapse border border-black table-auto overflow-scroll">
            <thead className="bg-[#808080] text-white">
              <tr>
                <Th>ดูข้อมูล</Th>
                <Th>ID</Th>
                <Th>ชื่อจริง</Th>
                <Th>นามสกุล</Th>
                <Th>เพศ</Th>
                <Th>อายุ</Th>
                <Th>โรงเรียน</Th>
              </tr>
            </thead>
            <tbody>
              {users?.users?.map((user: any, s: number) => (
                <tr className="text-center" key={s}>
                  <Td>
                    <div className="flex justify-center">
                      <button
                        type="button"
                        onClick={() =>
                          navigate(
                            `${
                              infomationLink[
                                role as keyof typeof infomationLink
                              ]
                            }${user._id}`,
                          )
                        }
                      >
                        <FaSearch fontSize={16} className="text-black" />
                      </button>
                    </div>
                  </Td>
                  <Td>{user.username}</Td>
                  <Td>{user.name}</Td>
                  <Td>{user.surname}</Td>
                  <Td>{user.gend === 'male' ? 'ชาย' : 'หญิง'}</Td>
                  <Td>{getAgeInThaiFormat(user.dob)}</Td>
                  <Td>{user.school?.sch_name}</Td>
                </tr>
              ))}
              {!users?.users?.length && (
                <tr className="text-center">
                  <Td colSpan={11}>ไม่พบข้อมูล</Td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="flex justify-center mt-2">
            <Pagination
              page={page}
              count={users.count}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Th = tw.th`py-2 px-4 font-normal border border-black`;

const Td = tw.td`py-2 px-4 font-normal border`;

const Input = tw.input`w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 text-black outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark`;

export default SearchUser;
